import { render, staticRenderFns } from "./SubfolderEditForm.vue?vue&type=template&id=2afaa862"
import script from "./SubfolderEditForm.vue?vue&type=script&lang=js"
export * from "./SubfolderEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports